export default __webpack_public_path__ + "static/media/GothamBold.108854bb.ttf";